import { request } from "./request.js";
function _log(data){
    request({
        url:"/webdoki/log",
        crossOrigin:false,
        hybrid:false,
        method:"post",
        data:data
    });
}
var Performance= {
    timing:function(pageName){
        if(typeof performance !="undefined"){
            var timing=performance.timing;

            var _browserLaunching=timing.fetchStart-timing.navigationStart;
            var _preWaiting=timing.requestStart-timing.fetchStart;
            var _waitingServer=timing.responseStart-timing.requestStart;
            var _delivering=timing.responseEnd-timing.responseStart;
            var _whiteScreenTime=timing.domContentLoadedEventEnd-timing.domLoading;
            //var _loadTime=timing.loadEventEnd-timing.domLoading;

            var param={
                pageName:pageName||"",
                event:"timing",
                type:"performance",
                browserLaunching:_browserLaunching,
                preWaiting:_preWaiting,
                waitingServer:_waitingServer,
                delivering:_delivering,
                whiteScreenTime:_whiteScreenTime
            }
            try {
                var timeTotal = _browserLaunching + _preWaiting + _waitingServer + _delivering + _whiteScreenTime;
                if (timeTotal > 10000) {
                    param.type = "error";
                }
                _log(param);
            }catch (e) {
                //_log(param);
            }
        }
    },
    error:function(e){
        var _e;
        try{
            _e=JSON.stringify(e,["message","type","isTrusted"]);
        }catch (ce) {
            _e=e;
        }
        _log({
            event:"dokiScriptError",
            type:"error",
            e:_e,
            url:window.location.href
        });
    },
    log:_log
};
export {
    Performance
};
